import Vue from "vue";
import My from "../components/MyTickets.vue";

Vue.component("my-tickets", My);
